(() => {
  const STORAGE_KEY = 'twf_wishlist_v1';

  function readWishlist() {
    try {
      const saved = JSON.parse(
        localStorage.getItem(STORAGE_KEY) || '[]'
      );

      return Array.isArray(saved) ? saved : [];
    } catch (error) {
      console.error(
        'TWF Wishlist: 목록을 읽지 못했습니다.',
        error
      );

      return [];
    }
  }

  function writeWishlist(items) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(items)
      );
    } catch (error) {
      console.error(
        'TWF Wishlist: 목록을 저장하지 못했습니다.',
        error
      );
    }
  }

  function containsProduct(items, productId) {
    return items.some(
      (item) => String(item.id) === String(productId)
    );
  }

  function updateButton(button, active) {
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));

    const label = active
      ? 'Aus Merkliste entfernen'
      : 'Zur Merkliste hinzufügen';

    button.setAttribute('aria-label', label);
    button.setAttribute('title', label);
  }

  function updateAllMatchingButtons(productId, active) {
    document
      .querySelectorAll('[data-twf-wishlist-button]')
      .forEach((button) => {
        if (
          String(button.dataset.productId) ===
          String(productId)
        ) {
          updateButton(button, active);
        }
      });
  }

  function updateWishlistCounters(items = readWishlist()) {
    document
      .querySelectorAll('[data-twf-wishlist-count]')
      .forEach((counter) => {
        counter.textContent = `(${items.length})`;
        counter.hidden = false;
      });
  }

  function initializeWishlist(root = document) {
    const items = readWishlist();

    root
      .querySelectorAll('[data-twf-wishlist-button]')
      .forEach((button) => {
        const productId = button.dataset.productId;

        if (!productId) return;

        updateButton(
          button,
          containsProduct(items, productId)
        );
      });

    updateWishlistCounters(items);
  }

  function toggleProduct(button) {
    const productId = button.dataset.productId;

    if (!productId) return;

    const items = readWishlist();

    const existingIndex = items.findIndex(
      (item) => String(item.id) === String(productId)
    );

    let active = false;

    if (existingIndex >= 0) {
      items.splice(existingIndex, 1);
    } else {
      items.push({
        id: productId,
        variantId: button.dataset.variantId || '',
        handle: button.dataset.productHandle || '',
        title: button.dataset.productTitle || '',
        url: button.dataset.productUrl || '',
        price: button.dataset.productPrice || '',
        currency:
          button.dataset.productCurrency || '€',
        image: button.dataset.productImage || ''
      });

      active = true;
    }

    writeWishlist(items);
    updateAllMatchingButtons(productId, active);
    updateWishlistCounters(items);
    renderWishlistPage();

    document.dispatchEvent(
      new CustomEvent('twf:wishlist-updated', {
        detail: {
          count: items.length,
          items
        }
      })
    );
  }

  function escapeHtml(value) {
    return String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function createWishlistCard(item) {
    const page = document.querySelector('[data-twf-wishlist-page]');

    const addToCartText =
  page?.dataset.addToCartText || 'Add to cart';

    const removeText =
  page?.dataset.removeText || 'Remove';

    const article = document.createElement('article');

    article.className = 'twf-wishlist-card';
    article.dataset.productId = item.id;

    const safeTitle = escapeHtml(
      item.title || 'Produkt'
    );

    const safeUrl = escapeHtml(item.url || '#');
    const safeImage = escapeHtml(item.image || '');
    const safePrice = escapeHtml(item.price || '');

    const safeCurrency = escapeHtml(
      item.currency || '€'
    );

    const safeProductId = escapeHtml(item.id || '');

    const safeVariantId = escapeHtml(
      item.variantId || ''
    );

    article.innerHTML = `
      <div class="twf-wishlist-card__image">
        <a href="${safeUrl}">
          ${
            safeImage
              ? `
                <img
                  src="${safeImage}"
                  alt="${safeTitle}"
                  loading="lazy"
                >
              `
              : ''
          }
        </a>
      </div>

      <div class="twf-wishlist-card__content">
        <h2 class="twf-wishlist-card__title">
          <a href="${safeUrl}">
            ${safeTitle}
          </a>
        </h2>

        ${
          safePrice
            ? `
              <p class="twf-wishlist-card__price">
                ${safeCurrency}${safePrice}
              </p>
            `
            : ''
        }

        <div class="twf-wishlist-card__actions">
          ${
            safeVariantId
              ? `
                <button
                  type="button"
                  class="button button--primary"
                  data-twf-add-to-cart
                  data-variant-id="${safeVariantId}"
                >
                  ${addToCartText}
                </button>
              `
              : `
                <a
                  href="${safeUrl}"
                  class="button button--primary"
                >
                  Produkt ansehen
                </a>
              `
          }

          <button
            type="button"
            class="button button--secondary"
            data-twf-wishlist-remove
            data-product-id="${safeProductId}"
          >
            ${removeText}
          </button>
        </div>
      </div>
    `;

    return article;
  }

  function renderWishlistPage() {
    const grid = document.querySelector(
      '[data-twf-wishlist-grid]'
    );

    const emptyState = document.querySelector(
      '[data-twf-wishlist-empty]'
    );

    if (!grid || !emptyState) return;

    const items = readWishlist();

    grid.innerHTML = '';

    if (items.length === 0) {
      emptyState.hidden = false;
      grid.hidden = true;
      return;
    }

    emptyState.hidden = true;
    grid.hidden = false;

    items.forEach((item) => {
      grid.appendChild(createWishlistCard(item));
    });
  }

  function updateHeaderCartCount(itemCount) {
  const count = String(itemCount);

  /* 아이콘 옆 숫자만 표시하는 헤더 설정 */
  document
    .querySelectorAll('.wbcartitem')
    .forEach((element) => {
      element.textContent = count;
    });

  /* 숫자와 금액을 함께 표시하는 헤더 설정 */
  document
    .querySelectorAll('.wbqtyboth')
    .forEach((element) => {
      element.textContent = count;
    });

  /* Warenkorb (7) 형식 */
  document
    .querySelectorAll('.qty_title')
    .forEach((element) => {
      const strongElements =
        element.querySelectorAll('strong');

      if (strongElements.length >= 2) {
        strongElements[
          strongElements.length - 1
        ].textContent = `(${count})`;
      }
    });

  /* 혹시 사용하는 다른 카트 카운터도 함께 갱신 */
  document
    .querySelectorAll(
      '[data-cart-count], .cart-count-bubble'
    )
    .forEach((element) => {
      element.textContent = count;
    });
}

  async function getCurrentCart(root) {
    const response = await fetch(
      `${root}cart.js`,
      {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(
        'Der Warenkorb konnte nicht geladen werden.'
      );
    }

    return response.json();
  }

  async function addVariantToCart(button) {
    const variantId = String(
      button.dataset.variantId || ''
    ).trim();

    if (!variantId) {
      alert(
        'Variant ID가 없습니다. 상품을 Wishlist에서 삭제한 뒤 다시 추가해 주세요.'
      );

      return;
    }

    const originalText =
      button.textContent.trim();

    button.disabled = true;
    const page = document.querySelector('[data-twf-wishlist-page]');

    const addingText =
  page?.dataset.addingText || 'Adding...';

    const addedText =
  page?.dataset.addedText || 'Added ✓';

    const errorText =
  page?.dataset.errorText || 'Error';

    button.textContent = addingText;

    try {
      const root =
        window.Shopify?.routes?.root || '/';

      const response = await fetch(
        `${root}cart/add.js`,
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1
              }
            ]
          })
        }
      );

      const responseData =
        await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(
          responseData.description ||
            responseData.message ||
            'Produkt konnte nicht hinzugefügt werden.'
        );
      }

      /*
       * 추가가 끝난 뒤 최신 장바구니 정보를 다시 가져온다.
       */
      const cart = await getCurrentCart(root);

      /*
       * 헤더의 Warenkorb 숫자를 새로고침 없이 변경한다.
       */
      updateHeaderCartCount(
        Number(cart.item_count || 0)
      );

      button.textContent = addedText;

      /*
       * 테마 또는 다른 코드가 사용할 수 있도록 이벤트도 발송한다.
       */
      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          detail: { cart }
        })
      );

      document.dispatchEvent(
        new CustomEvent('twf:cart-updated', {
          detail: { cart }
        })
      );

      window.setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 1600);
    } catch (error) {
      console.error(
        'TWF Wishlist Cart Error:',
        error
      );

      button.textContent = errorText;

      alert(
        `장바구니 추가 실패:\n${
          error.message ||
          '알 수 없는 오류가 발생했습니다.'
        }`
      );

      window.setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 1800);
    }
  }

  document.addEventListener('click', (event) => {
    const wishlistButton = event.target.closest(
      '[data-twf-wishlist-button]'
    );

    if (wishlistButton) {
      event.preventDefault();
      event.stopPropagation();

      toggleProduct(wishlistButton);
      return;
    }

    const addToCartButton = event.target.closest(
      '[data-twf-add-to-cart]'
    );

    if (addToCartButton) {
      event.preventDefault();

      addVariantToCart(addToCartButton);
      return;
    }

    const removeButton = event.target.closest(
      '[data-twf-wishlist-remove]'
    );

    if (!removeButton) return;

    event.preventDefault();

    const productId =
      removeButton.dataset.productId;

    const items = readWishlist().filter(
      (item) =>
        String(item.id) !== String(productId)
    );

    writeWishlist(items);
    updateAllMatchingButtons(productId, false);
    updateWishlistCounters(items);
    renderWishlistPage();
  });

  function initializeAll() {
    initializeWishlist();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAll
    );
  } else {
    initializeAll();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeWishlist(event.target);
      renderWishlistPage();
    }
  );

  window.addEventListener(
    'storage',
    initializeAll
  );
})();